<template>
    <v-expansion-panel-content>
        <slot></slot>

        <div class="mt-6 fixable_content d-flex justify-end" color="darkgrey">
            <span @click="toggleFixed" class="clickable">
                {{ fixed ? 'Desafixar Painel' : 'Fixar Painel' }}
                <v-icon class="ml-5" style="font-size:20px;margin-top: 0px;">
                    {{ fixed ? 'mdi-pin' : 'mdi-pin-outline' }}
                </v-icon>
            </span>
        </div>
    </v-expansion-panel-content>
</template>

<script>
  export default {
    name: 'ExpansionPanelContentFixable',
    props: {
      tab: {
        type: String,
        required: true
      },
      fixed: {
        type: Boolean,
        required: true
      }
    },
    methods: {
      toggleFixed () {
        this.$emit('toggleFixed', this.key)
      }
    }
  }
</script>

<style scoped lang="scss">
.fixable_content {
  position:block;
  bottom:10px;
  color:var(--darkgrey);
  font-weight: 600;
  right:10px;
}

.clickable{
  cursor:pointer;
}
</style>
